.item {
    display: inline-block;
    padding: 0;
    margin: 0;
    text-decoration: none;
    color: #575d6d;
    transition: color 0.5s;
    line-height: 1.5rem;
    font-size: 1.1rem;
}

.link {
    display: inline-block;
    padding: 0;
    margin: 0;
    text-decoration: none;
    color: #575d6d;
    transition: color 0.5s;
    line-height: 1.5rem;
    font-size: 1.1rem;
    cursor: pointer;

    &:hover {
        color: rgb(105, 112, 132);
        text-decoration: underline;
    }
}